import AOS from 'aos'
import 'aos/dist/aos.css'
import { nextTick } from 'vue'

export default defineNuxtPlugin((nuxtApp) => {
  if (import.meta.client) {
    let isAosInitialized = false

    nuxtApp.hook('app:mounted', async () => {
      // 等 Vue 完成 hydration 後再讓 AOS 修改 data-aos 元素的 class，避免 hydration mismatch。
      await nextTick()
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          AOS.init({
            // 全域設定
            duration: 800, // 動畫持續時間 (ms)
            easing: 'ease-in-out', // 補間動畫
            once: false, // 每次滾動都會觸發動畫
            mirror: true, // 向上滾動時反向播放動畫
            offset: 100, // 距離元素多少像素時觸發動畫
            anchorPlacement: 'top-bottom', // 動畫觸發相對於視窗的位置
            disable: false, // 不禁用動畫
          })
          isAosInitialized = true
        })
      })
    })

    nuxtApp.hook('page:finish', async () => {
      if (!isAosInitialized) return

      // 路由切換後等待頁面 DOM 更新，再重新計算共用 Layout（包含 Footer）的位置。
      await nextTick()
      requestAnimationFrame(() => {
        AOS.refreshHard()
      })
    })
  }

  return {
    provide: {
      aos: AOS
    }
  }
})
